import { useState } from 'react';
import { useResizeObserver } from './useResizeObserver';
/**
 * @returns an element's width / height observed by IntersectionObserver,
 * and ref to detect its resize event
 */
export function useElementSize() {
    const [width, setWidth] = useState(-1);
    const [height, setHeight] = useState(-1);
    const [contentWidth, setContentWidth] = useState(-1);
    const [contentHeight, setContentHeight] = useState(-1);
    const [paddingWidth, setPaddingWidth] = useState(-1);
    const [paddingHeight, setPaddingHeight] = useState(-1);
    const ref = useResizeObserver((entry) => {
        // contentRect: content size only
        const { width: contentWidth, height: contentHeight } = entry.contentRect;
        // target: content + padding + border size
        const target = entry.target;
        const { width, height } = target.getBoundingClientRect();
        setWidth(width);
        setHeight(height);
        setContentWidth(contentWidth);
        setContentHeight(contentHeight);
        setPaddingWidth(width - contentWidth);
        setPaddingHeight(height - contentHeight);
    });
    return { ref, width, height, contentWidth, contentHeight, paddingWidth, paddingHeight };
}
